/* eslint-disable react/function-component-definition, react/destructuring-assignment, react/prop-types */
import React, { useEffect, useMemo, useState } from 'react'
import { Checkbox } from '../Checkbox'
import './Table.module.scss'

function Selection(props) {
  const { checked, disabled, indeterminate } = props // eslint-disable-line react/prop-types
  return <Checkbox readOnly checked={checked} disabled={disabled} indeterminate={indeterminate} />
}

const selectionRenderer =
  (loading) =>
  ({ disabled, ...rest }) => <Selection {...rest} disabled={disabled || loading} />

const onSelect =
  ({ keyField, externalOnSelect, selectedData, setSelectedData }) =>
  (row, isSelect) => {
    const result = isSelect ? selectedData.concat(row) : selectedData.filter((item) => item[keyField] !== row[keyField])

    setSelectedData(result)
    externalOnSelect(result)
  }

const onSelectAll =
  ({ keyField, externalOnSelect, allData, nonSelectable, setSelectedData }) =>
  (isSelect) => {
    const result = isSelect ? allData.filter((row) => !nonSelectable.includes(row[keyField])) : []
    setSelectedData(result)
    externalOnSelect(result)
    // returning keys causes the library to set _this.selected synchronously instead of via CWRP
    return result.map((row) => row[keyField])
  }

const useSelectRow = ({ keyField, externalOnSelect, selected, nonSelectable, loading, readOnly, allData }) => {
  const [selectedData, setSelectedData] = useState([])

  const result = useMemo(
    () => ({
      selected: selectedData.map((item) => item[keyField]),
      onSelect: onSelect({
        keyField,
        externalOnSelect,
        selectedData,
        setSelectedData,
      }),
      onSelectAll: onSelectAll({ keyField, externalOnSelect, allData, nonSelectable, setSelectedData }),
      nonSelectable,
      mode: 'checkbox',
      classes: 'Uic-Table-selected',
      selectionRenderer: selectionRenderer(loading),
      selectionHeaderRenderer: selectionRenderer(loading),
    }),
    [selectedData, keyField, externalOnSelect, loading, nonSelectable, allData],
  )

  useEffect(() => {
    if (Array.isArray(selected)) {
      setSelectedData(selected)
    }
  }, [selected])

  // for the row selection to be enabled user has to pass onSelect to Table
  return !readOnly && externalOnSelect ? result : undefined
}

export default useSelectRow
